import React, { useState } from "react";
import { Controller } from "react-hook-form";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SelectedCountryCode from "./SelectedCountryCode";
import { ICountry } from "models/app";
import { countriesList } from "config";

interface CountryCodeFormProps {
  name: string;
  control: any;
  selectedCountryCode?: string;
  onChange?: (country: string) => void;
  defaultValue?: any;
  disabled?: boolean;
  label?: string;
}

const CountryCodeForm: React.FC<CountryCodeFormProps> = ({
  name,
  control,
  defaultValue = "SA",
  onChange,
  disabled,
  label = "Country Code",
}) => {
  // Set default country based on provided code or default to "SA"
  const defaultCountry = countriesList.find(
    (country) => country.phoneNumberCode === defaultValue
  );
  const [selectedCountry, setSelectedCountry] = useState<ICountry | null>(
    defaultCountry || null
  );

  const handleSelectCountryCode = (country: ICountry) => {
    setSelectedCountry(country);
    onChange && onChange(country.phoneNumberCode);
  };

  return (
    <Stack spacing={1} >
      <Controller
        control={control}
        name={name}
        defaultValue={selectedCountry}
        render={({ field }) => (
          <SelectedCountryCode
            selectedCountry={selectedCountry!}
            label={label}
            onChange={(e: any) => {
              handleSelectCountryCode(e);
              field.onChange(e);
            }}
            disabled={disabled}
          />
        )}
      />
    </Stack>
  );
};

export default CountryCodeForm;
